import { useMutation } from "@apollo/client";
import { StackScreenProps } from "@react-navigation/stack";
import {
  Page,
  Stack,
  TextField,
  Button,
} from "@towersystems/roam-common-native";
import { CashMovementType } from "@towersystems/roam-common/lib/generated-types";
import { useEffect } from "react";
import { ShiftRootParamList } from "../../../../types";
import { MUTATION_CREATE_CASH_MOVEMENT } from "../../../../utilities/terminal-shift/constants";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { useEndOfShiftContextProvider } from "../../utils/shift/hooks";
import { useCollectCashForm } from "../../utils/use-collect-cash-form";

export interface AddCashToOpenShiftScreenProps
  extends StackScreenProps<ShiftRootParamList, "AddCashToOpenShiftScreen"> {}

export const AddCashToOpenShiftScreen = ({
  navigation,
}: AddCashToOpenShiftScreenProps) => {
  const { shiftTerminal } = useEndOfShiftContextProvider();
  const [f] = useMutation(MUTATION_CREATE_CASH_MOVEMENT);
  const shouldFocus = useHasTransitionEnded(navigation);

  const { submitting, setAmount, amount, isDirty, isValid, note, setNote } =
    useCollectCashForm();

  async function handleOnConfirm() {
    return f({
      variables: {
        input: {
          openTerminalClosureId: shiftTerminal.openTerminalClosureId,
          amount: parseFloat(amount),
          type: CashMovementType.CASH_IN,
          note: note,
        },
      },
    })
      .then(() => navigation.navigate("OpenShiftScreen"))
      .catch((err) => console.log(err));
  }

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <Button
          label="Confirm"
          isAction
          disabled={!isValid || !isDirty || submitting}
          onPress={handleOnConfirm}
          size="compact"
        ></Button>
      ),
    });
  }, [handleOnConfirm, submitting, isDirty, isValid]);

  return (
    <Page>
      <Stack vertical>
        <TextField
          label="Amount"
          placeholder="Amount"
          value={amount}
          onChangeText={setAmount}
          keyboardType="numeric"
          autoFocus={shouldFocus}
          formatterType={isValid ? "money" : undefined}
          validationMessage={isValid ? undefined : "Invalid Amount"}
        />
        <TextField
          label="Note"
          placeholder="Note"
          value={note}
          onChangeText={setNote}
        />
      </Stack>
    </Page>
  );
};
